import { useEffect, useMemo, useState } from 'react';
import { getUiBootstrap, trackUiUsageEvent, type UiBootstrapMenuItem, type UiBootstrapPayload } from '@/lib/cms';

export function useUiBootstrap() {
  const [bootstrap, setBootstrap] = useState<UiBootstrapPayload>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    getUiBootstrap()
      .then((data) => {
        if (mounted) setBootstrap(data ?? {});
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  const api = useMemo(() => {
    const features = bootstrap.features ?? {};
    const menus = bootstrap.menus ?? {};

    const isFeatureEnabled = (featureKey?: string): boolean => {
      if (!featureKey) return true;
      return Boolean(features[featureKey]);
    };

    const getMenu = (location: string): UiBootstrapMenuItem[] => {
      const groups = menus[location] ?? [];
      return groups.flatMap((group) => group.items ?? []);
    };

    const canRender = (opts: { featureKey?: string; hasData?: boolean; hasPermission?: boolean; hasSubscription?: boolean }): boolean => {
      const { featureKey, hasData = true, hasPermission = true, hasSubscription = true } = opts;
      return isFeatureEnabled(featureKey) && hasData && hasPermission && hasSubscription;
    };

    return { features, menus, isFeatureEnabled, getMenu, canRender };
  }, [bootstrap]);

  const trackClick = (buttonKey: string, metadata?: Record<string, unknown>) => {
    trackUiUsageEvent({ event_type: 'button_clicked', button_key: buttonKey, metadata });
  };

  return {
    loading,
    bootstrap,
    ...api,
    trackClick,
  };
}

